/**
 * @file 请求包装
 * @author  fangsimin
 * @date    2019-01-14 15:14:23
 * @last Modified by    fangsimin
 * @last Modified time  2019-01-14 20:02:45
 */

import axios from 'axios';
import qs from 'qs';
// let hasInterception = false;
let pending = []; // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let CancelToken = axios.CancelToken;
let cancelPending = (pe) => {
    for (let p in pending) {
        // 当当前请求在数组中存在时执行函数体
        if (pending[p].u === pe.url + '&' + pe.method) {
            pending[p].f(); // 执行取消操作
            pending.splice(p, 1); // 把这条记录从数组中移除
        }
    }
};
axios.interceptors.request.use(config => {
    // console.log(config, 'sss');
    // hasInterception = config.hasInterception;
    if (config.hasInterception) {
        cancelPending(config); // 在一个ajax发送前执行一下取消操作
        config.cancelToken = new CancelToken(c => {
            // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
            pending.push({u: config.url + '&' + config.method, f: c});
        });
    }
    return config;
}, error => {
    return Promise.reject(error);
});
// 求时的拦截器
// axios.interceptors.request.use(config => {
//     // 发送请求之前做一些处理,loading...
//     config.data = qs.stringify(config.data);
//     return config;
// },
// error => {
//     // 当请求异常时做一些处理
//     return Promise.reject(error);
// });

// 请求完成后的拦截器
axios.interceptors.response.use(response => {
    // 返回响应时做一些处理
    // 在一个ajax响应后再执行一下取消操作，把已经完成的请求从pending中移除
    cancelPending(response.config);
    return response;
},
error => {
    // 当响应异常时做一些处理
    // 这里我们把错误信息扶正, 后面就不需要写 catch 了
    // cmp 403 处理
    if (error.status === 403) {
        this.$message.error(this.$i18n.t('message.permission'));
        return false;
    }
    if (axios.isCancel(error)) {
        // 判断是否取消了请求
        return Promise.reject(error.response);
    }
    return Promise.resolve(error.response);
});

/**
 * 请求失败时的初步处理回调
 * @param  {Object} response 返回
 * @return  {Object} response 返回
 */
function errorState(response) {
    if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
        return response;
    } else {
        return null;
    }
}

/**
 * 请求成功返回时的初步处理回调
 * @param  {Object} response 返回
 * @return {boolean} 返回服务端的code是否为0
 */
function successState(response) {
    if (response.data && +response.data.code === 0) {
        return true;
        // 上传接口 响应体 与其他接口不同
    } else if (response.config.url.indexOf('/upload') > -1) {
        return true;
    } else {
        return false;
    }
    // 一判断后端返回的错误码
    // if (res.data.errCode == '000002') {
    //   console.log(res.data.errDesc || '网络异常')
    // } else if (res.data.errCode != '000002' && res.data.errCode != '000000') {
    //   console.log(res.data.errDesc || '网络异常')
    // }
}

// 文件下载
function downloadFile(data, fileName, type) {
    const url = window.URL.createObjectURL(new Blob([data], {type: type}));
    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export default (opts, data) => {
    if (!opts.method) {
        opts.method = 'get';
    }
    // 公共参数
    let defaultParam = {
        // 'testParam': ''
    };
    // http默认配置
    let httpDefaultOpts = {
        baseURL: opts.baseURL,
        hasInterception: opts.hasInterception,
        method: opts.method, // 基础 url 前缀
        url: opts.url, // 请求的地址
        timeout: 0 // 超时时间, 单位毫秒
    };
    if (opts.method === 'get') {
        httpDefaultOpts['params']
            = Object.assign(defaultParam, opts.params, data);
        httpDefaultOpts['headers'] = {
            // 'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Content-Type': 'application/json; charset=UTF-8'
        };
        // cmp 上传 formdata 不需要序列化
    } else if (httpDefaultOpts.url.indexOf('/upload') > -1
        || httpDefaultOpts.url.indexOf('/uploadcreativeexcel') > -1
        || opts.formDataType) {
        httpDefaultOpts['data'] = data;
        // 开户传数组
    } else {
        httpDefaultOpts['data']
            = opts.qs
                ? qs.stringify(Object.assign(defaultParam, opts.data, data))
                : Object.assign(defaultParam, opts.data, data);
        httpDefaultOpts['headers'] = {
            // 'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': opts.contentType || 'application/x-www-form-urlencoded; charset=UTF-8'
            // 'dump_type': opts.dump_type || undefined
        };
    }
    if (opts.arrayFormat) {
        httpDefaultOpts['data'] = qs.stringify(Object.assign(defaultParam, opts.data, data), {arrayFormat: 'indices'});
    }
    if (opts.type === 'download') {
        httpDefaultOpts['responseType'] = 'arraybuffer';
        return new Promise((resolve, reject) => {
            axios(httpDefaultOpts).then(response => {
                if (+response.status === 200) {
                    const header = response.headers;
                    const fileName = (
                        header['content-disposition']
                        && header['content-disposition'].split('filename=')[1]
                    ) || 'filename';
                    downloadFile(response.data, fileName, opts.fileType);
                    resolve(true);
                } else {
                    // if (+response.status === 401) {
                    //     this.$message.error(this.$i18n.t('message.permissionDenied'));
                    //     setTimeout(() => {
                    //         window.location.replace('/adx-dc/logout.do');
                    //     }, 500);
                    // }
                    reject(response);
                }
            }).catch(response => {
                errorState(response);
                reject(response);
            });
        });
    } else {
        httpDefaultOpts['responseType'] = 'json';
    }
    return new Promise(function (resolve, reject) {
        axios(httpDefaultOpts).then(response => {
            if (successState(response)) {
                resolve(response.data);
            } else {
                reject(response);
            }
        }).catch(response => {
            errorState(response);
            reject(response);
        });
    });
};



// WEBPACK FOOTER //
// ./src/common/request.js